import { Box } from '@dtx-company/design-system/src'
import { FC } from 'react'

export const SelectorFrame: FC = () => (
  <Box
    sx={theme => ({
      content: '""',
      position: 'absolute',
      height: `calc(100% + ${theme.spacing(4)})`,
      width: `calc(100% + ${theme.spacing(4)})`,
      top: `${theme.spacing(-2)}`,
      left: `${theme.spacing(-2)}`,
      border: `${theme.spacing(1)} solid ${theme.palette.tertiary.main}`,
      borderRadius: 'inherit'
    })}
  />
)
